<div class="field mb-2 w-full" [ngClass]="options?.containerClass">
  <ng-container
    *ngIf="
      options?.fieldFormGroup || options?.fieldFormGroup === '';
      else elseTemplate
    "
  >
    <ng-container [formGroup]="specificFormGroup">
      <label class="mb-2" *ngIf="options.label">
        {{ options.label | translate }}
      </label>

      <p-dropdown
        [options]="options.dropdownOptions"
        [optionLabel]="options.optionLabel"
        [placeholder]="options.placeholder"
        [formControlName]="options.formControlName"
        [optionValue]="options.optionValue"
        styleClass="w-full"
        (onChange)="onChangeValue($event)"
        [showClear]="false"
      ></p-dropdown>
    </ng-container>
  </ng-container>
  <ng-template #elseTemplate>
    <label class="mb-2" *ngIf="options?.label">
      {{ options?.label | translate }}
      <span
        *ngIf="options?.validators?.required"
        [pTooltip]="'BUTTONS.required' | translate"
        tooltipPosition="top"
        class="text-pink-500"
        >*
      </span>
    </label>
    <label *ngIf="!options?.label" class="opacity-0">.</label>
    <p-dropdown
      [options]="options?.dropdownOptions"
      [optionLabel]="options?.optionLabel"
      [placeholder]="options?.placeholder"
      [formControlName]="options?.formControlName"
      [optionValue]="options?.optionValue"
      [filter]="options?.filter"
      styleClass="w-full"
      (onChange)="onChangeValue($event)"
      [showClear]="false"
    ></p-dropdown>
  </ng-template>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
